import { checkRecipientsPermission } from './checkRecipientsPermission';
import { shouldCheckPermForLink } from './shouldCheckPermForLink';
import { getSharingLinkInfo, lazyRemoveRecipientsFromLink, SharingLinkInfo } from 'owa-link-data';
import { format } from 'owa-localize';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { trace } from 'owa-trace';
import {
    GetPermissionInfoStatus,
    RecipientPermissionInfo,
    lazyHasGetRecipientPermissionFailed,
} from 'owa-sharing-data';

export async function updateRecipientsOnLink(
    linkId: string,
    recipientInfos: RecipientMemberInfo[],
    composeId: string
) {
    const sharingLinkInfo: SharingLinkInfo = getSharingLinkInfo(linkId);
    if (!sharingLinkInfo) {
        return;
    }
    if (!shouldCheckPermForLink(linkId)) {
        return;
    }

    const linkUrl = sharingLinkInfo.unwrappedUrl
        ? sharingLinkInfo.unwrappedUrl
        : sharingLinkInfo.url;
    const hasGetRecipientPermissionFailed = await lazyHasGetRecipientPermissionFailed.import();
    handleRemovedRecipients(
        sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos,
        recipientInfos,
        linkId
    );

    if (hasGetRecipientPermissionFailed(sharingLinkInfo.sharingRecipientsInfo)) {
        return;
    }

    const newRecipientPermissionInfos: RecipientPermissionInfo[] = getNewRecipients(
        sharingLinkInfo.sharingRecipientsInfo.recipientPermissionInfos,
        recipientInfos
    );

    await checkRecipientsPermission(newRecipientPermissionInfos, linkId, linkUrl, composeId);
}

/* export for test purpose*/
export function getNewRecipients(
    recipientsInLinkStore: RecipientPermissionInfo[],
    recipientInfos: RecipientMemberInfo[]
): RecipientPermissionInfo[] {
    const newRecipients: RecipientMemberInfo[] = recipientInfos.filter(function(recipientInfo) {
        return !findEmailAddress(recipientInfo.emailAddress, recipientsInLinkStore);
    });
    const newRecipientPermissionInfos: RecipientPermissionInfo[] = [];
    newRecipients.forEach(newRecipient => {
        newRecipientPermissionInfos.push({
            emailAddress: newRecipient.emailAddress,
            name: newRecipient.displayName,
            getPermissionInfoStatus: GetPermissionInfoStatus.InProgress,
            hasAccess: false,
        });
    });

    return newRecipientPermissionInfos;
}

/* export for test purpose*/
export async function handleRemovedRecipients(
    recipientsInLinkStore: RecipientPermissionInfo[],
    recipientInfos: RecipientMemberInfo[],
    linkId: string
) {
    const removedRecipients: RecipientPermissionInfo[] = recipientsInLinkStore.filter(function(
        recipientPermissionInfo
    ) {
        return !findEmailAddress(recipientPermissionInfo.emailAddress, recipientInfos);
    });

    // Update store
    if (removedRecipients.length > 0) {
        trace.info(
            format(
                'RecipientPermission: LinkId:{0}, remove {1} recipients ',
                linkId,
                removedRecipients.length
            )
        );
        const removeRecipientsFromLink = await lazyRemoveRecipientsFromLink.import();
        removeRecipientsFromLink(linkId, removedRecipients);
    }
}

interface InfoWithEmailAddress {
    emailAddress: string;
}

export function findEmailAddress(emailAddress: string, infos: InfoWithEmailAddress[]): boolean {
    return infos.some(info => info.emailAddress === emailAddress);
}
